import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IUnprocessedTransactionsMeta{
  dateTreatment: FormInputMeta,
  bank: FormInputMeta,
  status: FormInputMeta,
  sourceType: FormInputMeta,
  
  schema: any,
}

const UnprocessedTransactionsMeta: IUnprocessedTransactionsMeta = {} as IUnprocessedTransactionsMeta;

UnprocessedTransactionsMeta.bank = commonFormMeta.bank;
UnprocessedTransactionsMeta.status = commonFormMeta.status;
UnprocessedTransactionsMeta.sourceType = commonFormMeta.sourceType;

UnprocessedTransactionsMeta.dateTreatment = {
  label: 'Date Treatment',
  name: 'date-treatment',
  type: 'date',
  placeholder: 'Select Date',
  validation: yup.string().required(),
}

const validationSchema: any = {};

for (let fieldname in UnprocessedTransactionsMeta) {
  validationSchema[fieldname] = (UnprocessedTransactionsMeta as any)[fieldname].validation;
}

UnprocessedTransactionsMeta.schema = yup.object().shape(validationSchema);

export default UnprocessedTransactionsMeta;

